<template>
    <div class="details-grid">
        <div v-if="booking_type === 'now'" class="details-row">
            <div class="details-block">
                Parking ends at
            </div>
            <div class="details-block">
                {{ bookingEnd }}
            </div>
        </div>
        <div class="details-row">
            <div class="details-block">
                Total Cost
            </div>
            <div class="details-block">
                <template v-if="quote.value">
                    £{{ quote.value | currencyFormat }}
                </template>
                <template v-else>
                    <i class="fa fa-spinner fa-spin" />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapReducers } from '../../../../modules/reducer';
    import { currencyFormat } from '../../../../filters/index';

    export default {
        name: 'checker-details-grid',

        filters: { currencyFormat },

        computed: {
            ...mapReducers('$store.state.booking.reservation_details', 'booking/updateReservationData', [
                'bookings',
                'booking_type',
                'duration',
            ]),

            /** Start proxied values for SaneDates */
            ...['end_date', 'end_time', 'quote'].reduce((computed, prop) => ({
                ...computed,
                [prop]() {
                    return this.booking[prop];
                },
            }), {}),
            /** End proxied values for SaneDates */

            /**
             * Get the booking from the bookings array
             * @return {Object} booking
             */
            booking() {
                return this.bookings[0];
            },

            /**
             * Get the end date and time for the booking
             * @return {String}
             */
            bookingEnd() {
                const endDateTime = moment(`${ this.end_date } ${ this.end_time }`, 'DD-MM-YYYY HH:mm');
                return endDateTime.format('ddd, DD MMM HH:mm');
            },

            endTime() {
                const startTime = moment();
                const bookingLength = this.duration;

                return startTime.add(bookingLength, 'minutes').format('ddd, DD MMM HH:mm');
            },
        },
    };
</script>

<style lang="less" scoped>
    @import "../../../../../less/variables.less";
    @import (reference) "../../../../../../../node_modules/bootstrap/less/mixins/grid.less";
    @import (reference) "../../../../../../../node_modules/bootstrap/less/mixins/clearfix.less";

    .availability-bookingtype {
        .details {
            &-grid {
                display: flex;
                flex-direction: column;
                border-top: 1px solid #e3e3e3;
                margin: 20px -10px 0;
            }

            &-row {
                width: 100%;
                border-bottom: 1px solid #e3e3e3;
            }

            &-block {
                .make-xs-column(6);
                border-bottom: none;
                padding: 15px 10px;
                font-size: 14px;

                &:first-of-type {
                    font-weight: 600;
                }

                &:last-of-type {
                    text-align: right;
                }
            }
        }
    }
</style>
